import type { Archive, GameTask } from "../../domain/types";
interface Template extends Omit<
  GameTask,
  "id" | "source" | "status" | "settlementDone"
> {
  templateId: string;
}
export async function refreshTaskBoard(archive: Archive, force = false) {
  if (!archive.player.profile.profession.hasHunterLicense)
    throw new Error("该角色没有猎人资格，无法使用任务板");
  if (
    !force &&
    archive.tasks.available.some((t) => t.status === "available") &&
    archive.tasks.lastRefreshDay === archive.gameTime.day
  )
    return archive;
  const pools = await Promise.all(
    Array.from({ length: archive.player.hunter.hr }, (_, i) =>
      fetch(`/data/quest-pool/star${i + 1}.json`)
        .then((r) => r.json())
        .catch(() => ({ records: [] })),
    ),
  );
  const all = pools
    .flatMap((p) => p.records as Template[])
    .filter(
      (t) => !archive.tasks.history.some((h) => h.templateId === t.templateId),
    );
  const seed =
    (archive.gameTime.day * 1103515245 + archive.name.length * 12345) >>> 0;
  const picked = [...all]
    .sort(
      (a, b) =>
        ((hash(a.templateId) + seed) >>> 0) -
        ((hash(b.templateId) + seed) >>> 0),
    )
    .slice(0, 5);
  const next = structuredClone(archive);
  const active = next.tasks.available.filter(
    (t) => t.status === "active" || t.status === "completed",
  );
  next.tasks.available = [
    ...active,
    ...picked.map((t, i) => ({
      ...t,
      id: `T_${next.gameTime.day}_${i + 1}`,
      source: "preset" as const,
      status: "available" as const,
      settlementDone: false,
    })),
  ];
  next.tasks.lastRefreshDay = next.gameTime.day;
  return next;
}
function hash(s: string) {
  let h = 0;
  for (const c of s) h = (Math.imul(31, h) + c.charCodeAt(0)) | 0;
  return h >>> 0;
}
